import React from 'react'
import styled from '../../config/theme'

export default function Card ({ children, style }: CardProps) {
  return (
    <Container style={{...style}}>
      {children}
    </Container>
  )
}

export interface CardProps {
  children: React.ReactNode
  style?: any
}

const Container = styled.div`
  background-color: #fff;
  padding: 40px;
  margin: 20px;
  box-shadow: 0 3px 9px 0 rgba(169,184,200,.15);
`
